import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from '../components/BrandLogo';
import { PageMeta } from '../components/PageMeta';
import { CONTACT } from '../config';

export function VendorsPage() {
  const { t } = useTranslation();
  const [status, setStatus] = useState<'idle' | 'ok' | 'err'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('idle');
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((value, key) => {
      body.append(key, value.toString());
    });

    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('ok');
        form.reset();
      } else {
        setStatus('err');
      }
    } catch {
      setStatus('err');
    }
  };

  return (
    <>
      <PageMeta
        titleKey="vendorsPage.metaTitle"
        descriptionKey="vendorsPage.metaDescription"
      />

      <div className="vendors vendors--branded">
      <div className="vendors-brand">
        <BrandLogo variant="combo" className="vendors-logo" alt="Shmatch" />
      </div>
      <h1>{t('vendorsPage.title')}</h1>
      <p className="vendors-intro">{t('vendorsPage.intro')}</p>

      <dl className="contact-cards">
        <div className="contact-card">
          <dt>{t('vendorsPage.phoneLabel')}</dt>
          <dd>
            <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a>
          </dd>
        </div>
        <div className="contact-card">
          <dt>{t('vendorsPage.emailLabel')}</dt>
          <dd>
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          </dd>
        </div>
      </dl>

      <form
        name="vendor-contact"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={handleSubmit}
      >
        <input type="hidden" name="form-name" value="vendor-contact" />
        <p className="honeypot">
          <label>
            Don’t fill this out: <input name="bot-field" />
          </label>
        </p>

        <div className="form-group">
          <label htmlFor="vc-name">{t('vendorsPage.formName')}</label>
          <input id="vc-name" name="name" type="text" required autoComplete="name" />
        </div>
        <div className="form-group">
          <label htmlFor="vc-venue">{t('vendorsPage.formVenue')}</label>
          <input id="vc-venue" name="venueName" type="text" autoComplete="organization" />
        </div>
        <div className="form-group">
          <label htmlFor="vc-email">{t('vendorsPage.formEmail')}</label>
          <input id="vc-email" name="email" type="email" required autoComplete="email" />
        </div>
        <div className="form-group">
          <label htmlFor="vc-phone">{t('vendorsPage.formPhone')}</label>
          <input id="vc-phone" name="phone" type="tel" autoComplete="tel" />
        </div>
        <div className="form-group">
          <label htmlFor="vc-msg">{t('vendorsPage.formMessage')}</label>
          <textarea id="vc-msg" name="message" required />
        </div>

        <button type="submit" className="btn-primary">
          {t('vendorsPage.formSubmit')}
        </button>

        {status === 'ok' && (
          <p className="form-status form-status--ok" role="status">
            {t('vendorsPage.formSuccess')}
          </p>
        )}
        {status === 'err' && (
          <p className="form-status form-status--err" role="alert">
            {t('vendorsPage.formError')}
          </p>
        )}
      </form>
    </div>
    </>
  );
}
